export const PLAY_SONG = "PLAY_SONG";
export const ADD_SONG_TO_QUEUE = "ADD_SONG_TO_QUEUE";
export const PLAY_COLLECTION = "PLAY_COLLECTION";
export const PLAY_SONG_FROM_COLLECTION = "PLAY_SONG_FROM_COLLECTION";
export const SAVE_STATS = "SAVE_STATS";
